export default {
  Satchel: {
    InstallerSatchel: {
      Menu: ' کارتابل مدیر نصب',
    },
    ManagementSatchel: {
      Menu: ' کارتابل مدیریت',
    },
    ProductSatchel: {
      Menu: 'کارتابل مدیر تولید',
    },
    ProductExport: {
      Menu: 'پروژه های خروج زده شده',
    },
    SellSatchel: {
      Menu: 'کارتابل مدیر فروش',
      Add: 'افزودن پروژه جدید',
      AddPart: 'افزودن پارت جدید',
      Search: 'جستجوی قرارداد ',
    },
    BuySatchel: {
      Menu: 'کارتابل مسئول خرید',
    },
    AccountantSatchel: {
      Menu: 'کارتابل حسابداری',
    },
  },
}
